import { LoadingCircle } from "../common";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { CartComparisonTable } from "./cartComparisonTable";
import { compareProperties } from "../../services/compareProperties";
import { usePropertyStore } from "../../stores/newStores/cartComparisonStore";

const CartComparison = () => {
  const {
    filteredPropertiesCompare,
    setProperties,
    properties,
    pinnedProperty,
  } = usePropertyStore();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchComparison = async () => {
      const listingIds = filteredPropertiesCompare.map(
        (property) => property.listingId
      );
      setLoading(true);
      try {
        const comparisonResult = await compareProperties(listingIds);

        const sortedListings = comparisonResult.listings.sort((a, b) => {
          if (a.listingId === pinnedProperty) {
            return -1;
          }
          if (b.listingId === pinnedProperty) {
            return 1;
          }
          return 0;
        });

        setProperties(sortedListings);
      } catch (error) {
        console.error("Error during comparison:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchComparison();
  }, []);

  return (
    <div className="">
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <div
        className="cursor-pointer flex items-center gap-2 p-1 mb-3"
        onClick={() => navigate("/")}
      >
        <IoArrowBackSharp className="text-xl" />
        <span>Back</span>
      </div>
      <div className="flex justify-between items-center">
        <div className="text-z-shark text-[40px] font-semibold">
          Compare Properties
        </div>
      </div>
      <div
        className={`w-full text-black space-y-6 pt-5 pb-6 ${
          loading || properties.length === 0 ? "h-full" : ""
        } bg-white`}
      >
        {!loading && properties.length === 0 && (
          <div className="flex items-center text-center justify-center flex-col h-full w-full px-4 space-y-8 mt-40">
            <div className="space-y-3">
              <div className="font-bold text-4xl">Oops !</div>
              <div className="text-3xl">
                No added <span className="text-[#FF5757]">properties</span> to
                compare
              </div>
            </div>
            <button
              type="button"
              className="bg-z-dark-moss-green shadow-xl text-white w-[31.25rem] font-bold text-xl py-3.5 rounded-full"
              onClick={() => navigate("/")}
            >
              Add homes
            </button>
          </div>
        )}
        {loading ? (
          <div className="flex items-center justify-center h-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <LoadingCircle />
          </div>
        ) : (
          <CartComparisonTable />
        )}
      </div>
    </div>
  );
};

export { CartComparison };
